import {ErrorHandler, inject, Injectable} from "@angular/core";
import {SecureStorageService} from "../modules/core/services/secure-storage.service";
import {LocalStorageRelatedData} from "../local-storage-related-data.model";

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
    private secureStorageService = inject(SecureStorageService)

    handleError(error: any): void {
        const msg = (error as Error | undefined)?.message ?? "";
        const chunkFailed = /ChunkLoadError|Loading chunk \d+ failed/i;

        if (chunkFailed.test(msg)) {
            const { origin, pathname } = window.location;
            // After a failed lazy-nav Angular rolls the URL back to '/',
            // so reloading pathname would strand the user at root instead
            // of the page they clicked. Log and continue.
            if (pathname === "/" || pathname === "") {
                console.error("ChunkLoadError at root — refusing to reload to '/'. Original error:", error);
            } else if (!this.secureStorageService.getSessionItem(LocalStorageRelatedData.SessionStorage.CHUNK_RELOAD_DONE)) {
                this.secureStorageService.setSessionItem(LocalStorageRelatedData.SessionStorage.CHUNK_RELOAD_DONE, "1");
                const bust = `?refresh=${Date.now()}`;
                if ("caches" in window) {
                    try {
                        caches.keys().then((keys) => keys.forEach((k) => caches.delete(k)));
                    } catch (e) {
                        console.error("Error clearing caches", e);
                    }
                }
                window.location.replace(`${origin}${pathname}${bust}`);
                return;
            }
        }

        // Always log errors to console for debugging
        console.error(error);
    }
}
